import React, { useEffect, useCallback, useState } from "react";
import { BiChevronRight, BiChevronLeft } from "react-icons/bi";
import styles from "./SideScrollButtons.module.scss";
import debounce from "lodash.debounce";
import useWindowSize from "lib/hooks/useWindowSize";

const SideScrollButtons = ({
  cardRowRef,
  type = "contained",
  isCardRow = true,
}) => {
  const [currentScrollLeft, setCurrentScrollLeft] = useState(0);
  const [maxScrollWidth, setMaxScrollWidth] = useState(0);

  const screenWidth = useWindowSize().width;

  useEffect(() => {
    let scrollContainer = cardRowRef?.current ?? cardRowRef;

    if (!cardRowRef.current.classList.contains("wn-scroll-container")) {
      scrollContainer = cardRowRef.current.querySelector(
        ".wn-scroll-container"
      );
    }

    if (!scrollContainer) {
      return;
    }

    scrollContainer.addEventListener(
      "scroll",
      debounce(() => {
        setCurrentScrollLeft(scrollContainer.scrollLeft);
      }, 50)
    );

    setMaxScrollWidth(
      scrollContainer?.scrollWidth - scrollContainer?.clientWidth
    );
  }, [cardRowRef, screenWidth]);

  const handleSideScrollClick = useCallback(
    (event, direction) => {
      let scrollContainer = cardRowRef.current;

      if (!cardRowRef.current.classList.contains("wn-scroll-container")) {
        scrollContainer = cardRowRef.current.querySelector(
          ".wn-scroll-container"
        );
      }

      event.stopPropagation();

      const currentScroll = scrollContainer.scrollLeft;

      const width = scrollContainer.offsetWidth;
      const elementWidth = scrollContainer.querySelector(
        ":scope > :first-child"
      ).offsetWidth;

      const rightScrollAmount =
        width < 600
          ? currentScroll + elementWidth * 1.05
          : currentScroll + width * 0.8;
      const leftScrollAmount =
        width < 600
          ? currentScroll - elementWidth * 1.05
          : currentScroll - width * 0.8;

      scrollContainer.scrollTo({
        left: direction === "right" ? rightScrollAmount : leftScrollAmount,

        behavior: "smooth",
      });
    },
    [cardRowRef]
  );

  if (!maxScrollWidth) {
    return null;
  }

  return (
    <div className={`${styles.buttonContainer} ${styles[type]}`}>
      <button
        className={`${styles.cardScrollButton} ${styles.left} ${
          currentScrollLeft < 5 ? styles.hide : ""
        }`}
        onClick={(event) => {
          handleSideScrollClick(event, "left");
        }}
        aria-label="Side scroll left"
        data-direction="left"
      >
        <BiChevronLeft size="100%" />
      </button>

      <button
        className={`${styles.cardScrollButton} ${styles.right} ${
          maxScrollWidth - 10 <= currentScrollLeft ? styles.hide : ""
        }`}
        onClick={(event) => {
          handleSideScrollClick(event, "right");
        }}
        aria-label="Side scroll right"
        data-direction="right"
      >
        <BiChevronRight size="100%" />
      </button>
    </div>
  );
};

SideScrollButtons.displayName = "SideScrollButtons";
export default SideScrollButtons;
